import { motion } from "framer-motion";
import CountdownTimer from "./CountdownTimer";

const LOGO_URL = "./img/knots-logo.png";

// Set event date to 2 weeks from now for demo
const getEventDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 14);
  date.setHours(10, 0, 0, 0);
  return date.toISOString();
};

const HeroSection = () => {
  return (
    <section
      className="section-wrapper relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 py-16 sm:py-20 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Pattern */}
      <div className="chinese-pattern opacity-20" />

      {/* Content Container */}
      <div className="relative z-10 text-center max-w-3xl mx-auto w-full">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-5 sm:mb-8"
        >
          {/* <img
            src={LOGO_URL}
            alt="KNOTS Wedding Organizer"
            className="w-20 sm:w-28 md:w-36 h-auto mx-auto"
            style={{
              filter: "drop-shadow(0 4px 12px rgba(212, 175, 55, 0.3))",
            }}
            data-testid="hero-logo"
          /> */}
          {/* Double Happiness Symbol */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mb-4 sm:mb-6"
          >
            <span
              className="double-happiness text-3xl sm:text-3xl md:text-5xl font-bold"
              data-testid="double-happiness-symbol"
            >
              囍
            </span>
          </motion.div>
        </motion.div>

        {/* Decorative Line */}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="w-16 sm:w-24 h-px bg-[#D4AF37] mx-auto mb-5 sm:mb-8"
        />

        {/* The Sangjit Ceremony Label */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="font-serif-accent text-[10px] sm:text-xs md:text-sm tracking-[0.2em] sm:tracking-[0.3em] text-[#D4AF37] uppercase mb-4 sm:mb-6"
        >
          The Sangjit Ceremony of
        </motion.p>

        {/* Couple Names */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="font-serif-heading text-3xl sm:text-5xl md:text-7xl lg:text-8xl text-[#8B0000] mb-1 sm:mb-2"
          data-testid="couple-names"
        >
          Michelle
        </motion.h1>

        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.8 }}
          className="font-serif-heading text-xl sm:text-2xl md:text-3xl text-[#D4AF37] block mb-1 sm:mb-2"
        >
          &
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.9 }}
          className="font-serif-heading text-3xl sm:text-5xl md:text-7xl lg:text-8xl text-[#8B0000] mb-5 sm:mb-8"
        >
          Kevin
        </motion.h1>

        {/* Date */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1 }}
          className="font-serif-accent text-[10px] sm:text-sm md:text-base tracking-[0.15em] sm:tracking-[0.2em] text-[#5A5A5A] mb-8 sm:mb-12"
        >
          Sunday, January 26th, 2025
        </motion.p>

        {/* Countdown Timer */}
        {/* <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1.1 }}
        >
          <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] text-[#D4AF37] uppercase mb-4 sm:mb-6">
            Counting Down
          </p>
          <CountdownTimer targetDate={getEventDate()} />
        </motion.div> */}
      </div>

      {/* Corner Decorations - smaller on mobile */}
      <div className="absolute top-4 left-4 sm:top-8 sm:left-8 w-12 h-12 sm:w-20 sm:h-20 border-l-2 border-t-2 border-[#D4AF37] opacity-30" />
      <div className="absolute top-4 right-4 sm:top-8 sm:right-8 w-12 h-12 sm:w-20 sm:h-20 border-r-2 border-t-2 border-[#D4AF37] opacity-30" />
      <div className="absolute bottom-4 left-4 sm:bottom-8 sm:left-8 w-12 h-12 sm:w-20 sm:h-20 border-l-2 border-b-2 border-[#D4AF37] opacity-30" />
      <div className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 w-12 h-12 sm:w-20 sm:h-20 border-r-2 border-b-2 border-[#D4AF37] opacity-30" />
    </section>
  );
};

export default HeroSection;
